import { useRef, useState } from "react";
import { Controller } from 'react-hook-form';
import { useForm } from 'react-hook-form';
import FormInputField from '../../common/components/formElements/FormInputField';
import { Link } from 'react-router-dom';
import imgsearch from './../../images/serch-icon.png';
import { useNavigate } from 'react-router-dom';
import { Appointment } from '../../v2/services/Appointment';

export default function SearchDoctor() {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');

    const {
        register,
        handleSubmit
    } = useForm();

    const onSearch = async (data) => {
        const { dui, email } = data;
        
        // Validate that at least one field is filled
        if (!dui && !email) {
            setError('Debe llenar al menos un campo (DUI o Email)');
            return;
        }

        setIsLoading(true);
        setError('');

        try {
            // Navigate to results page with search parameters
            navigate('/search-doctor-results', {
                state: {
                    searchParams: {
                        dui: dui || null,
                        email: email || null
                    }
                }
            });
        } catch (err) {
            console.error('Error navigating to results:', err);
            setError('Error al procesar la búsqueda. Inténtelo de nuevo.');
        } finally {
            setIsLoading(false);
        }
    };


    return (
        <div className="bg-dl-screen-lightblue lg:px-8 mx-auto px-4 relative sm:px-6">
            <div className="grid grid-cols-12 gap-12">
                <div className="col-span-12 md:col-span-12 search-box-top-main">
                    <form onSubmit={handleSubmit(onSearch)} className="docter-link-form">
                        {error !== '' && (
                            <div className="mb-8 bg-blue-100 border-t-4 border-blue-500 rounded-b text-blue-900 px-4 py-3 shadow-md">
                                <div className="flex">
                                    <div className="py-1">
                                        <svg
                                            className="fill-current h-6 w-6 text-blue-500 mr-4"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 20 20"
                                        >
                                            <path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z" />
                                        </svg>
                                    </div>
                                    <div>
                                        <p className="font-bold mb-4">{error}</p>
                                        {error.includes('Error al buscar') && (
                                            <button
                                                type="button"
                                                onClick={() => setError('')}
                                                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                                            >
                                                Reintentar
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className="form-field-box-main w-90">
                            <div className="field-1 form-field-box z-30">
                                <FormInputField
                                    label="Numero De Dui"
                                    type="text"
                                    name="dui"
                                    id="dui"
                                    placeholder="Ingrese el numero de DUI del paciente"
                                    registration={register('dui')}
                                />
                            </div>

                            <div className="field-1 form-field-box z-30">
                                <FormInputField
                                    label="Correo Electronico Del Paciente"
                                    type="email"
                                    name="email"
                                    id="email"
                                    placeholder="Ingrese el correo electronico del paciente"
                                    registration={register('email')}
                                />
                            </div>

                            <div className="search-btn-box">
                                <button 
                                    type="submit" 
                                    className="submit-btn"
                                    disabled={isLoading}
                                >
                                    <div>
                                        <img
                                            className="h-8 w-auto mr-1.5 flex justify-center"
                                            src={imgsearch}
                                            alt="DoctoLink"
                                        />
                                    </div>
                                    {isLoading ? 'Buscando...' : 'Buscar Citas'}
                                </button>
                            </div>
                        </div>
                    </form>

                </div>
            </div>
        </div>
    );
}